import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderPrykarpattya(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-prykarpattya/create-distribution-order-prykarpattya",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderPrykarpattya(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-prykarpattya/create-distribution-to-order-prykarpattya",
      params,
      callBackFn
    );
  },
  async getPrykarpattyaAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-prykarpattya/get-prykarpattya-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
